// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","BlueBar":"ZLYxRA","BlueBarItem":"_3wpNXB","fadeInFrames":"_1SJa5F"};